import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { setupAxiosAuth } from './api/axios.instance';
import { router } from './router/routes';
import { LoadingIndicator } from './components/LoadingIndicator/LoadingIndicator';
import { AlertIndicator } from './components/AlertIndicator/AlertIndicator';
import './App.css';

function App() {
  const { getAccessTokenSilently, logout } = useAuth0();

  useEffect(() => {
    setupAxiosAuth(
      getAccessTokenSilently,
      () => logout({ logoutParams: { returnTo: window.location.origin } })
    );
  }, [getAccessTokenSilently, logout]);

  return (
    <>
      <LoadingIndicator />
      <AlertIndicator />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
